import { FaHome, FaBell, FaBookmark, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";   // ✅ added

function Header() {
  const navigate = useNavigate();   // ✅ added

  return (
    <div className="header">
      <div className="logo" onClick={() => navigate("/")}>
        TravelMedia.in
      </div>

      <div className="nav-icons">
        <FaHome onClick={() => navigate("/")} />
        <FaBell onClick={() => navigate("/notifications")} />
        <FaBookmark onClick={() => navigate("/bookmarks")} />
        <FaUser onClick={() => navigate("/profile")} />
      </div>
    </div>
  );
}

export default Header;